<template>
<div class="chapter">
<div class="inner_page">
<section id="pt1" title="I. Stories Not Collected Before in Book Form:">
<p class="part_head"><span class="right_1" epub:type="pagebreak" id="page_xviii" title="xviii"><span class="right_1" epub:type="pagebreak" id="page_1" title="1"><a href="#/text/9780063075771_Contents#rpt1">The Thurber Carnival</a></span></span></p>
<div class="fig_50"><img alt="image" src="images/f0001-01.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780063075771_Part_1.vue?04f0065f